module.exports = __webpack_public_path__ + "static/img/knowledgenew6.d310b791.png";